import {Duration} from 'luxon';

import {MetricNumericalRenderer} from '../analyticsFormatHelpers';

const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = 60 * SECONDS_IN_MINUTE;
const SECONDS_IN_DAY = 24 * SECONDS_IN_HOUR;
const SECONDS_IN_YEAR = 365 * SECONDS_IN_DAY;

export const renderDurationValue: MetricNumericalRenderer<string> = ({value, isCompact}) => {
  const isNegative = value < 0; // Luxon doesn't support correctly the formatting of negative durations https://github.com/moment/luxon/issues/415.

  const numberOfSeconds = Math.abs(value);

  if (numberOfSeconds === 0) {
    return '-';
  }

  const duration = Duration.fromObject({seconds: numberOfSeconds});

  let formattedDuration: string | undefined;

  if (numberOfSeconds < SECONDS_IN_MINUTE) {
    formattedDuration = duration.toFormat("s's'");
  } else if (numberOfSeconds < SECONDS_IN_HOUR) {
    formattedDuration =
      numberOfSeconds % SECONDS_IN_MINUTE === 0 ? duration.toFormat("m'm'") : duration.toFormat("m'm' s's'");
  } else if (numberOfSeconds < SECONDS_IN_DAY) {
    formattedDuration =
      numberOfSeconds % SECONDS_IN_HOUR === 0 ? duration.toFormat("h'h'") : duration.toFormat("h'h' m'm'");
  }
  // For durations over a year, in non-compact mode we display the number of days, otherwise '> 1 year".
  else if (numberOfSeconds < SECONDS_IN_YEAR || !isCompact) {
    formattedDuration =
      numberOfSeconds % SECONDS_IN_DAY === 0 ? duration.toFormat("d'd'") : duration.toFormat("d'd' h'h'");
  } else {
    formattedDuration = '> 1 year';
  }

  if (isNegative) {
    return `-${formattedDuration}`;
  }

  return formattedDuration;
};
